import { Reveal } from "./Reveal";

const Block = ({ data, testid }) => (
  <div className="border-t border-line pt-6" data-testid={testid}>
    <h3 className="font-display text-2xl text-ink mb-5">{data.title}</h3>
    <ul className="space-y-3">
      {data.items.map((it, i) => (
        <li key={i} className="flex gap-3 text-sm md:text-base text-ink-2 leading-relaxed">
          <span className="text-accent mt-1 shrink-0">—</span>
          <span>{it}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const Experience = ({ t }) => {
  const e = t.experience;
  return (
    <section id="experience" className="py-24 md:py-32 lg:py-40 bg-secondary/50 border-y border-line" data-testid="experience-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-green mb-6">{e.eyebrow}</p>
          <h2 className="font-display font-medium text-4xl md:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.02] max-w-3xl mb-16 md:mb-20">
            {e.title}
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-x-12 md:gap-y-14">
          <Reveal delay={0.0}><Block data={e.background} testid="exp-background" /></Reveal>
          <Reveal delay={0.06}><Block data={e.education} testid="exp-education" /></Reveal>
          <Reveal delay={0.12}><Block data={e.certificates} testid="exp-certificates" /></Reveal>
          <Reveal delay={0.18}><Block data={e.languages} testid="exp-languages" /></Reveal>
        </div>
      </div>
    </section>
  );
};
